import { render, staticRenderFns } from "./DetailsLedger.vue?vue&type=template&id=14c3a58e&lang=pug&"
import script from "./DetailsLedger.vue?vue&type=script&lang=js&"
export * from "./DetailsLedger.vue?vue&type=script&lang=js&"
import style0 from "./DetailsLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetailsLedger.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {
  VContainer,
})
